import { newsService } from "@/common/api.service";

const initialStates = {
    status: "loading",

    form_data: {
        subject: "",
        newscontent: "",
    },
    newslist: "",
    Count_News_Not_visited: "",
    newsById: {},
};

const mutations = {
    loading(state) {
        state.status = "loading";
    },
    success(state, store) {
        state.status = "success";
        state.form_data = store;
    },
    fail(state) {
        state.status = "fail";
    },
    set_news_list(state, store) {
        state.status = "success";
        state.newslist = store;
    },
    set_Count_News_Not_visited(state, store) {
        state.status = "success";
        state.Count_News_Not_visited = store;
    },
    setnewsById(state, store) {
        state.status = "success";
        state.newsById = store;
    },
};
const getters = {
    status: ({ status }) => status,
    form_data: ({ form_data }) => form_data,
};

const actions = {
    find({ commit }, hashid) {
        commit("loading");
        return newsService.find(hashid).then((response) => {
            commit("success", response.data.data);
        });
    },
    set_Count_News_Not_visited_function: function({ commit }) {
        commit("loading");
        return newsService.CountNewsNotvisited().then((response) => {
            commit("set_Count_News_Not_visited", response.data.data);
        });
    },
    getnews: function({ commit }) {
        commit("loading");

        return newsService.getnews().then((response) => {
            commit("set_news_list", response.data.data);
        });
    },
    findNewsById({ commit }, newsid) {
        commit("loading");
        return newsService.findNewsById(newsid).then((response) => {
            commit("setnewsById", response.data.data);
        });
    },
};

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
};
